import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AdminListComponent } from './admin-list.component';
import { AdminUserCommentsService } from '../../../services/admin/adminUserComments.service';

@Component({
    selector: 'app-admin-user-comments-dialog',
    templateUrl: './admin-user-comments-dialog.component.html',
    standalone: false
})
export class AdminUserCommentsComponent implements OnInit {

  public commentText: string = '';
  public userId: string = '';

  constructor(
    public adminUserCommentsService: AdminUserCommentsService,
    public dialogRef: MatDialogRef<AdminListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.commentText = this.data.commentText;
    this.userId = this.data.userId;
  }

  save() {
    this.adminUserCommentsService.addData(this.userId, this.commentText).then(response => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
